
export default function SloganPart({ items, currentIndex, fade }) {
  return (
    <section>
        <div className="slogan_part">
            <p className={`footer-note small ${fade ? "fade-out" : "fade-in" }`} style={{ marginBottom:"0"}}>
              <span>
                <img src={items[currentIndex].icon} className="img_turner" />
                &nbsp;
              </span>
              {items[currentIndex].text}
            </p>
          </div>
    </section>
  );
}

